(function () {
  const STOPWORDS = [
    'a', 'o', 'as', 'os', 'um', 'uma', 'uns', 'umas',
    'de', 'da', 'do', 'das', 'dos', 'e', 'ou', 'em',
    'no', 'na', 'nos', 'nas', 'com', 'sem', 'por',
    'para', 'pra', 'ao', 'aos', 'à', 'às', 'que',
    'and', 'or', 'not'
  ];

  function unwrapStrictQuery(value) {
    const raw = String(value || '');
    return /^\s*title:/i.test(raw) ? raw.replace(/\s+AND\s+/g, ' ') : raw;
  }

  function toWords(value) {
    const words = unwrapStrictQuery(value)
      .replace(/title:/gi, ' ')
      .replace(/[*:()"'\,.;?!]/g, ' ')
      .split(/\s+/)
      .filter(Boolean);

    const kept = words.filter(function (word) {
      return STOPWORDS.indexOf(word.toLowerCase()) === -1;
    });

    return kept.length ? kept : words;
  }

  function strictSearchQuery(value) {
    const words = toWords(value);
    return words.length ? 'title:' + words.join('* AND title:') + '*' : '';
  }

  function humanizeSearchQuery(value) {
    return unwrapStrictQuery(value)
      .replace(/title:/gi, '')
      .replace(/\*/g, '')
      .replace(/\s+/g, ' ')
      .trim();
  }

  window.strictSearchQuery = strictSearchQuery;
  window.humanizeSearchQuery = humanizeSearchQuery;

  document.addEventListener('submit', function (event) {
    const form = event.target;
    if (!form || form.tagName !== 'FORM') return;

    const input = form.querySelector('input[name="q"]:not([type="hidden"])');
    if (!input) return;

    const query = strictSearchQuery(input.value);
    if (query) input.value = query;
  }, true);

  function humanizeVisibleInputs() {
    document.querySelectorAll('input[name="q"]:not([type="hidden"])').forEach(function (input) {
      const human = humanizeSearchQuery(input.value);
      if (human !== input.value) input.value = human;
    });
  }

  humanizeVisibleInputs();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', humanizeVisibleInputs);
  }
})();
